import { forwardRef } from 'react';
import { IPageSection } from '../../types';
import { ExpertAssistedPlans } from './expertPlans/expertPlans';

export const EASSection: React.FC<IPageSection> = forwardRef(
  (
    { id, postData, metaData },
    ref: React.ForwardedRef<HTMLDivElement>
  ): JSX.Element => {
    return (
      <div data-testid={id} id={id} ref={ref}>
        {metaData && postData ? (
          <ExpertAssistedPlans
            slug={postData.slug}
            planData={{
              eas_business: [
                ...(postData.eas_business && postData.eas_business.active
                  ? postData.eas_business && postData.eas_business.plans
                  : []),
              ],
              eas_itr: [
                ...(postData.eas_itr && postData.eas_itr.active
                  ? postData.eas_itr && postData.eas_itr.plans
                  : []),
              ],
            }}
            metaData={metaData}
          />
        ) : null}
      </div>
    );
  }
);

EASSection.displayName = 'EASSection';
